import {EyeClosedIcon, EyeIcon} from '@primer/octicons-react'
import styles from './FeatureIcon.module.css'

export function FeatureIcon(props: {enrolled: boolean}) {
  const {enrolled} = props

  if (enrolled) {
    return <EyeIcon aria-label="Feature enabled" className={styles.enrolledIcon} />
  }

  return <EyeClosedIcon aria-label="Feature disabled" />
}

try{ FeatureIcon.displayName ||= 'FeatureIcon' } catch {}